import type { Appointment as FhirAppointment } from '@medplum/fhirtypes';

/** Effective scheduled end (ms) from FHIR `end` or `start` + `minutesDuration`. */
export function fhirAppointmentEndMs(
  appt: Pick<FhirAppointment, 'start' | 'end' | 'minutesDuration'>,
): number {
  if (appt.end) {
    const end = new Date(appt.end).getTime();
    if (!Number.isNaN(end)) return end;
  }
  if (appt.start) {
    const start = new Date(appt.start).getTime();
    if (!Number.isNaN(start) && appt.minutesDuration != null && appt.minutesDuration > 0) {
      return start + appt.minutesDuration * 60_000;
    }
    if (!Number.isNaN(start)) return start;
  }
  return 0;
}

export function isFhirAppointmentUpcoming(
  appt: Pick<FhirAppointment, 'start' | 'end' | 'minutesDuration'>,
  nowMs = Date.now(),
): boolean {
  return fhirAppointmentEndMs(appt) > nowMs;
}

export function portalAppointmentEndMs(apt: { start: string; end: string }): number {
  const end = new Date(apt.end).getTime();
  if (!Number.isNaN(end)) return end;
  const start = new Date(apt.start).getTime();
  return Number.isNaN(start) ? 0 : start;
}

export function isPortalAppointmentUpcoming(
  apt: { start: string; end: string },
  nowMs = Date.now(),
): boolean {
  return portalAppointmentEndMs(apt) > nowMs;
}
